<template>
  <div class="bg w-100 py-0" id="comoSeLogra">
    <div class="container py-5">
      <h2 class="text-center" style="color: white;">¿Cómo se logra?</h2>
      <h4 style="color: white;" class="text-center">
        Tenemos un proceso para lograr lo que tienes en mente, con asistencia personalizada<br>
        para cubrir tus necesidades.
      </h4>
      <div class="row ">
        <div v-for="card in cards" class="col-12  col-lg-4">
          <img :src="card.img" alt="" class="p-5 mx-auto d-block" width="80%">
          <h3 class="text-center" style="color: white;">{{card.titulo}}</h3>
          <p class="px-4 text-justify d-line d-sm-none" style="color: white;" v-html="card.descripcion"></p>
        </div>
      </div>
      <div class="row justify-content-around px-4 d-none d-sm-flex">
        <div class="col-1 px-0">

        </div>
        <div class="col-1 px-0" style="max-width: 4%">
          <img :src="cards[0].numero" alt="" class=" mx-auto d-block my-3" width="100%">
        </div>
        <div class="col-3 px-0 " style="padding-top: 2%">
          <hr style="border: 1px solid white; width: 125%; position: relative; left: -13%">
        </div>
        <div class="col-1 px-0" style="max-width: 4%">
          <img :src="cards[1].numero" alt="" class="my-3" width="100%" >
        </div>
        <div class="col-3 px-0 " style="padding-top: 2%;">
          <hr style="border: 1px solid white; width: 125%; position: relative; left: -13%">
        </div>
        <div class="col-1 px-0" style="max-width: 4% !important;">
          <img :src="cards[2].numero" alt="" class=" mx-auto d-block my-3" width="100%">
        </div>
        <div class="col-1 px-0" >

        </div>
      </div>
      <div class="row d-none d-sm-flex">
        <div v-for="card in cards" class="col-4 ">
          <p class="px-4 text-justify" style="color: white;" v-html="card.descripcion"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //#0064A3

  //#2F395D
  import CardGradient from "./CardGradient";

  export default {
    name: "Gradient",
    components: {
      CardGradient
    },
    data() {
      return {
        linea: `./dist/numero_linea.svg`,
        cards: [{
          img: `./dist/05_registro.svg`,
          titulo: `Contacta con nosotros`,
          numero: `./dist/numero_01.svg`,
          descripcion: `Déjanos tus datos de contacto para
                        poder atenderte de manera más
                        personalizada.`
        }, {
          img: `./dist/06_evaluacion.svg`,
          titulo: `Evaluamos el problema`,
          numero: `./dist/numero_02.svg`,
          descripcion: `Envía tu problema o el desarrollo que
                        necesitas. Nosotros evaluamos las
                        diferentes soluciones para ti. <br>
                        <br>
                        Cada caso se trata de manera
                        personalizada.`
        }, {
          img: `./dist/07_smartphone.svg`,
          titulo: `Solución`,
          numero: `./dist/numero_03.svg`,
          descripcion: `Estamos siempre en contacto para
                        brindarte qué solución es la que
                        necesitas o el desarrollo que estás
                        solicitando.`
        }]
      }
    }
  }
</script>

<style scoped>

  .bg {
    background: rgba(0, 101, 163, 1);
    background: -moz-linear-gradient(top, rgba(0, 101, 163, 1) 0%, rgba(47, 57, 93, 1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(0, 101, 163, 1)), color-stop(100%, rgba(47, 57, 93, 1)));
    background: -webkit-linear-gradient(top, rgba(0, 101, 163, 1) 0%, rgba(47, 57, 93, 1) 100%);
    background: -o-linear-gradient(top, rgba(0, 101, 163, 1) 0%, rgba(47, 57, 93, 1) 100%);
    background: -ms-linear-gradient(top, rgba(0, 101, 163, 1) 0%, rgba(47, 57, 93, 1) 100%);
    background: linear-gradient(to bottom, rgba(0, 101, 163, 1) 0%, rgba(47, 57, 93, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#0065a3', endColorstr='#2f395d', GradientType=0);
  }


</style>
